import { key_from_value_map } from './babylon/utility/utils.js';
export class AssetCollection {
    constructor() {
        this._collection = new Map();
        this._id_counter = 0;
    }
    contains(id) {
        return this._collection.has(id);
    }
    next_id() {
        return this._id_counter;
    }
    add(v) {
        const id = this._id_counter++;
        this._collection.set(id, v);
        return id;
    }
    remove(id) {
        if (this.contains(id)) {
            return this._collection.delete(id);
        }
        return false;
    }
    get(id) {
        if (!this.contains(id)) {
            throw new Error(`No entry with id: ${id}`);
        }
        return this._collection.get(id);
    }
    find_id(value) {
        const result = key_from_value_map(this._collection, value);
        return result !== null && result !== void 0 ? result : -1;
    }
    set(id, v) {
        this._collection.set(id, v);
    }
    length() {
        return this._collection.size;
    }
    ids() {
        return Array.from(this._collection.keys());
    }
    values() {
        return Array.from(this._collection.values());
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    forEach(func) {
        this._collection.forEach(func);
    }
    clear() {
        this._collection.clear();
    }
    /*  Caution: Use with care. This can be used to force reset the Viewer's id_counter after removing all objects in a scene
        to enable recreating objects with the same IDs. */
    reset_object_id_counter() {
        this._id_counter = 0;
    }
    dispose() {
        for (const value of this._collection.values()) {
            if (value && typeof value === 'object' && 'dispose' in value && typeof value.dispose === 'function') {
                value.dispose();
            }
        }
        this._collection.clear();
    }
}
//# sourceMappingURL=AssetCollection.js.map